

/**
 * Converts a string to be a url friendly string
 * @param {string} str
 * @returns {string}
 */
export default function makeUrlFriendly(str){
  return str
    .toLowerCase()
    .replace(/ /g,'-')
    .replace(/[^\w-]+/g,'')

}


// WEBPACK FOOTER //
// ./src/lib/makeUrlFriendly.js